<template lang="html">
  <div
    class="error__message"
    :class="{
      'error__message--long': message.length > 300,
      'error__message--warning': type === 'warning',
    }"
    v-html="message"
  />
</template>

<script lang="js">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ErrorForm',
  props: {
    message: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'error', // warning || error
    },
  },
});
</script>

<style lang="scss" scoped>
.error__message {
  background-color: #ffe5e8;
  color: #df2436;
  border-radius: 4px;
  padding: 6px 5px;
  font-family: $font;
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 16px;
  text-align: center;

  &--warning {
    background-color: #f6ecd0;
    color: #c8711e;
  }

  &--long {
    text-align: left;
  }
}
</style>
